import { createContext, useContext } from 'react'

import { FeedActivityFilter } from '../domain/feed'

type EntitySortState = {
  activityType: FeedActivityFilter | undefined
  setActivityType: (type: FeedActivityFilter | undefined) => void
}

export const ActivityFeedFilterContext = createContext<EntitySortState | null>(null)

export const useActivityFeedFilter = () => {
  const context = useContext(ActivityFeedFilterContext)

  if (!context) {
    throw new Error('useActivityFeedFilter must be used within a ActivityFeedFilterContext')
  }

  return context
}
